import {
  DOWNLOAD_EMPLOYEE_DOCUMENTS,
  EMPLOYEE_DOCUMENT_STAGES_ALIAS,
  UPDATE_EMPLOYEE_DOCUMENTS,
} from '../../../constants';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/VisibilityOutlined';
import { DocumentStorageItemType } from 'framework/documentStorage';
import { useNavigate } from 'react-router-dom';
import { useEmployeeUrl } from 'domain/shared/employee';
import { useArtifactDownloadHelper } from 'domain/shared/artifact';
import { ErrorMessage, useMessageService } from 'framework/ui/Message';
import { DEFAULT_ERROR_MESSAGE } from 'framework/form';
import EditEmployeeDocumentAction from './EditEmployeeDocumentAction';
import AnnulEmployeeDocumentAction from './AnnulEmployeeDocumentAction';
import { useListContext } from 'framework/list';
import { useShowContext } from 'framework/show';
import { DropdownMenuActions } from 'framework/ui/menu';

const EmployeeDocumentListActions = () => {
  const navigate = useNavigate();
  const { addMessage } = useMessageService();
  const { getEmployeeDocumentsUrl } = useEmployeeUrl();
  const { updateInList } = useListContext();
  const { data } = useShowContext<DocumentStorageItemType>();

  const { downloadDocumentStorage } = useArtifactDownloadHelper();

  const documentData = data.getData();

  const handleDownload = async (filePath: string) => {
    try {
      await downloadDocumentStorage(filePath);
    } catch {
      addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
    }
  };

  return (
    <DropdownMenuActions
      actions={[
        {
          icon: <VisibilityIcon />,
          title: 'View',
          onClick: (entityData: DocumentStorageItemType) => {
            const encodedId = encodeURIComponent(entityData?.path);
            navigate(`${getEmployeeDocumentsUrl()}/${encodedId}`);
          },
        },
        {
          permission: UPDATE_EMPLOYEE_DOCUMENTS,
          isVisible: (entityData: DocumentStorageItemType) =>
            entityData?.metadata?.stage !== EMPLOYEE_DOCUMENT_STAGES_ALIAS.ANNULLED,
          form: {
            Component: EditEmployeeDocumentAction,
            title: 'Edit document',
            afterSubmit: {
              execute: updatedEnity => {
                updateInList!({
                  ...documentData,
                  metadata: {
                    ...documentData.metadata,
                    section: updatedEnity.section,
                    fileType: updatedEnity.fileType,
                    stage: updatedEnity.stage,
                    office: updatedEnity.office,
                    number: updatedEnity.number,
                    category: updatedEnity.category,
                  },
                } as any);
              },
            },
          },
          icon: <EditIcon />,
          title: 'Edit',
        },
        {
          permission: DOWNLOAD_EMPLOYEE_DOCUMENTS,
          onClick: (entityData: DocumentStorageItemType) => {
            handleDownload(entityData?.path);
          },
          icon: <DownloadIcon />,
          title: 'Download',
        },
        {
          permission: UPDATE_EMPLOYEE_DOCUMENTS,
          isVisible: (entityData: DocumentStorageItemType) =>
            entityData?.metadata?.stage !== EMPLOYEE_DOCUMENT_STAGES_ALIAS.ANNULLED,
          form: {
            Component: AnnulEmployeeDocumentAction,
            title: 'Are you sure?',
            afterSubmit: {
              execute: updatedEnity => {
                updateInList!({
                  ...documentData,
                  metadata: {
                    ...documentData.metadata,
                    annullingReason: updatedEnity.annullingReason,
                    stage: EMPLOYEE_DOCUMENT_STAGES_ALIAS.ANNULLED,
                  },
                } as any);
              },
            },
          },
          icon: <DeleteIcon />,
          title: 'Annul',
        },
      ]}
    />
  );
};

export default EmployeeDocumentListActions;
